var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFileword(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 39,
    viewBox: "0 0 30 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 12.7021V36.0193C30 36.5496 29.7893 37.0583 29.4143 37.4333C29.0393 37.8083 28.5306 38.019 28.0003 38.019H1.99974C1.46946 38.0187 0.960971 37.808 0.586006 37.433C0.211041 37.058 0.000266005 36.5495 0 36.0193V2.0178C0 1.48744 0.210708 0.978789 0.58573 0.603766C0.960753 0.228744 1.46937 0.0180665 1.99974 0.0180665H17.317C18.3948 0.0178404 19.4287 0.44574 20.1911 1.20766L28.8104 9.82699C29.5725 10.5897 30.0004 11.6239 30 12.7021Z",
    fill: "#439CF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04008 27.1217H11.9333L14.6026 17.9332H14.712L17.3924 27.1217H20.2876L24.3091 13.0674H21.0636L18.7376 22.8532H18.6131L16.0492 13.0674H13.2745L10.7075 22.8331H10.5911L8.26508 13.0674H5.01953L9.04008 27.1217Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileword);
export default __webpack_public_path__ + "static/media/fileword.3a7b70592a5313071a453e9c292d0c50.svg";
export { ForwardRef as ReactComponent };